import type { IconData } from '@stacksjs/iconify-core'

export const invisible1Flat: IconData = {
  "body": "<g fill=\"none\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#8fbffa\" d=\"M1.355 22.698C4.11 12.781 13.203 5.5 24 5.5c10.798 0 19.89 7.28 22.645 17.198a4.87 4.87 0 0 1 0 2.604C43.891 35.219 34.798 42.5 24 42.5S4.11 35.22 1.355 25.302a4.87 4.87 0 0 1 0-2.604m16.281-5.062l12.728 12.728a9 9 0 0 0-12.728-12.728\"/><path fill=\"#2859c5\" d=\"M1.232 1.232a2.5 2.5 0 0 1 3.536 0l42 42a2.5 2.5 0 0 1-3.536 3.536l-42-42a2.5 2.5 0 0 1 0-3.536\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default invisible1Flat
